<template>
  <div :class="['main', ispc ? '' : 'mobile_main']" v-loading.fullscreen.lock="loading">
    <div class="top_img">
      <div class="top_to_fb" @click="toFB"></div>
    </div>
    <div class="bot_img">
      <div class="bot_to_gl android_bot" @click="toGoogle" v-if="deviceType == 'android'"></div>
      <div class="bot_to_gl ios_bot" @click="toAppStore" v-if="deviceType == 'ios'"></div>
    </div>
    <div class="top_banenr">
      <img class="module_img" :src="require(`@/assets/xianni/${imgMid}2_01.jpg`)" alt="" />
      <div class="banner_btn" @click="reservaVisible = true"></div>
    </div>
    <div class="step" id="module_1">
      <img class="module_img" :src="require(`@/assets/xianni/${imgMid}2_02.jpg`)" alt="" />
      <div class="phone_input">
        <selectInput @confirm="phoneConfirm" :ispc="ispc"></selectInput>
      </div>
      <div class="download_btns">
        <div class="download_btn" @click="toAppStore"></div>
        <div class="download_btn goole_btn" @click="toGoogle"></div>
      </div>
      <div class="f_zan" @click="toFB"></div>
    </div>
    <div class="reservation_num" id="module_2">
      <div class="num_dc" :style="{ 'background-image': `url(${require(`@/assets/xianni/${imgMid}dc_0${reserveLv}.png`)})` }"></div>
      <div class="dj"></div>
      <div class="num_lv">
        <img :class="`lv_${reserveLv}`" :src="require(`@/assets/xianni/${imgMid}lv_${reserveLv}.png`)" alt="" />
      </div>
    </div>
    <div class="fans" id="module_3">
      <div class="fb_page_container">
        <div
          class="fb-page"
          data-href="https://www.facebook.com/xnmobiletw"
          data-tabs="timeline"
          :data-width="fbWidth"
          :data-height="fbHeight"
          data-small-header="false"
          data-adapt-container-width="true"
          data-hide-cover="false"
          data-show-facepile="true">
          <blockquote cite="https://www.facebook.com/xnmobiletw" class="fb-xfbml-parse-ignore">
            <a href="https://www.facebook.com/xnmobiletw">仙逆m-官方正版授權</a>
          </blockquote>
        </div>
      </div>
      <a class="tip" @click="report" target="_blank" href="https://www.facebook.com/xnmobiletw">
        如無法加載粉絲團預覽，請手動前往FB搜索“仙逆m-官方正版授權”參與互動活動呦~
      </a>
    </div>
    <div class="roles" id="module_4">
      <div class="role_names">
        <div class="n_item" v-for="(item, index) in roleNames" :key="index" @click="changeRoleType(index)">
          <img :src="item.cIcon" alt="" v-show="index == currRoleIndex" />
        </div>
      </div>
      <div class="roles_header">
        <div
          :class="['role_header', role == currRole ? 'curr_role' : '']"
          v-for="role in roleNames[currRoleIndex].roles"
          :key="role"
          @click="changeRole(role)">
          <img
            :src="
              require(`@/assets/xianni/${imgMid}roles/${role == currRole ? 'header' : 'header_c'}/${
                roleNames[currRoleIndex].type
              }/${role}.png`)
            "
            alt="" />
        </div>
      </div>
      <div class="skill_container">
        <img class="role_skill" :style="roleInfoSize" :src="require(`@/assets/xianni/${imgMid}roles/info/${currRole}.png`)" alt="" />
      </div>
    </div>
    <div class="bot_banner" id="module_5">
      <div class="acter_mid">
        <img :src="require(`../../assets/xianni/${imgMid}banner/left.png`)" class="zhua" @click="changeBanner($event, 'pre')" alt="" />
        <div class="acter_k">
          <div class="acter_swiper">
            <div
              :class="['swiper_list', isSwper ? 'is_swpier' : '']"
              :style="{ transform: `translateX(${bannerIndex * (ispc ? -58.4 : -84.13)}vw)` }"
              @transitionend="swiperEnd">
              <img :src="bannerList[bannerList.length - 1]" key="fir_i" alt="" />
              <img v-for="(item, index) in bannerList" :src="item" :key="index + 'ddd'" alt="" />
              <img :src="bannerList[0]" key="last_i" alt="" />
            </div>
          </div>
        </div>
        <img :src="require(`../../assets/xianni/${imgMid}banner/right.png`)" class="zhua" @click="changeBanner($event, 'next')" alt="" />
      </div>
      <img
        class="banner_pos"
        :src="require(`../../assets/xianni/${imgMid}banner/pos${bannerIndex > 5 ? 1 : bannerIndex < 1 ? 5 : bannerIndex}.png`)"
        alt="" />
    </div>
    <div class="bot_tips">
      <img src="@/assets/xianni/logo_white.png" alt="" class="logo_bot bot_icon" />
      <img src="@/assets/xianni/GSRR_PG_12.png" alt="" class="bot_icon" />
      <div class="tips">
        <p>※ 本軟體因涉及暴力，依遊戲軟體分級管理辦法分類為輔12級。</p>
        <p>※ 本遊戲為免費使用，遊戲內另提供購買虛擬遊戲幣、物品等付費服務。</p>
        <p>※ 長時間進行遊戲，請注意使用時間，避免沉迷於遊戲。</p>
        <p>※ 克里奥數位行銷有限公司</p>
        <div class="argu">
          <!-- <a target="_blank" href="https://www.amazingcat.ltd/userprotocol.html">服務條款</a> -->
          <a @click="toUserprotocol">服務條款</a>
          <!-- <a target="_blank" href="https://www.amazingcat.ltd/private.html">隱私協議</a> -->
          <a @click="toPrivate">隱私協議</a>
        </div>
      </div>
    </div>
    <div :class="['menu_list', `menu_list_${currMenu}`]" v-if="ispc">
      <div class="menu_item" v-for="index in 5" @click="changeMenu(index)"></div>
    </div>
    <el-dialog
      :visible.sync="sucVisible"
      width="78.94vw"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :modal="true"
      :modal-append-to-body="false">
      <div :class="['suc_dia', ispc ? '' : 'mobile_suc', `${deviceType}_suc`]">
        <div class="close" @click="sucVisible = false"></div>
        <div class="dia_btns">
          <div @click="toAppStore" class="apple_btn" v-show="ispc || isAppleDevice()"></div>
          <div @click="toGoogle" class="gl_btn" v-show="ispc || !isAppleDevice()"></div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="repeatVisible"
      width="78.94vw"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :modal="true"
      :modal-append-to-body="false">
      <div :class="['suc_dia', ispc ? '' : 'mobile_suc', 'repeat_phone']">
        <div class="close" @click="repeatVisible = false"></div>
        <div class="dia_fb" @click="toFB"></div>
      </div>
    </el-dialog>
    <el-dialog
      top="0"
      :visible.sync="reservaVisible"
      width="100vw"
      :lock-scroll="false"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :modal="true"
      :modal-append-to-body="false">
      <div class="reserva_dia">
        <div class="reserva_container">
          <img src="@/assets/xianni/reserva_pop_bg.png" class="reserva_pop_bg" alt="" />
          <div class="close" @click="closeReser"></div>
          <selectInput @confirm="phoneConfirm" :isCommon="false" :ispc="ispc"></selectInput>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { reserveRegUserPhone, reserveUserNum } from '@/api/index'
import buryingPoint from '@/mixins/buryingPoint'
import selectInput from '../component/selectInput.vue'

export function debounce(func, wait) {
  let timeout
  return function (...args) {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.apply(context, args)
    }, wait)
  }
}

export default {
  mixins: [buryingPoint],
  components: {
    selectInput
  },
  data() {
    return {
      fbWidth: 0,
      fbHeight: 0,
      roleNames: [],
      currRoleIndex: 0,
      currRole: '馬良',
      loading: false,
      roleInfoSize: {
        width: 0,
        height: 0
      },
      isSwper: false,
      bannerIndex: 1,
      bannerList: [],
      forbid: false,
      timer: null,
      reserveLv: 0,
      lvNum: [100000, 300000, 500000, 800000, 1000000],
      currMenu: 1,
      moduleScrolls: [],
      isScrolling: false,
      scrollTimer: null,
      sucVisible: false,
      reservaVisible: true,
      ispc: this.isPC(),
      deviceType: this.isPC() ? 'pc' : this.isAppleDevice() ? 'ios' : 'android',
      imgMid: '',
      repeatVisible: false,
      isReserved: localStorage.getItem('isReserved')
    }
  },
  watch: {
    ispc: {
      handler() {
        this.fbWidth = this.ispc ? Math.floor(24.34 * (innerWidth / 100)) : Math.floor(50.7 * (innerWidth / 100))
        this.fbHeight = this.ispc ? Math.floor(34.8 * (innerWidth / 100)) : Math.floor(57.2 * (innerWidth / 100))
        this.imgMid = this.ispc ? '' : 'mobile/'
        this.roleNames = [
          {
            cIcon: require(`../../assets/xianni/${this.imgMid}z_mo.png`),
            type: '魔',
            roles: ['馬良', '六欲魔君', '端木極']
          },
          {
            cIcon: require(`../../assets/xianni/${this.imgMid}z_xian.png`),
            type: '仙',
            roles: ['天運子', '周佚', '青霖']
          },
          {
            cIcon: require(`../../assets/xianni/${this.imgMid}z_ni.png`),
            type: '逆',
            roles: ['王林', '李慕婉', '司徒南']
          },
          {
            cIcon: require(`../../assets/xianni/${this.imgMid}z_yi.png`),
            type: '异',
            roles: ['拓森', '塗司', '朵目']
          },
          {
            cIcon: require(`../../assets/xianni/${this.imgMid}z_sl.png`),
            type: '神临',
            roles: ['永夜魔尊', '凌天侯', '遁天']
          }
        ]
        this.bannerList = [
          require(`../../assets/xianni/${this.imgMid}banner/1.png`),
          require(`../../assets/xianni/${this.imgMid}banner/2.png`),
          require(`../../assets/xianni/${this.imgMid}banner/3.png`),
          require(`../../assets/xianni/${this.imgMid}banner/4.png`),
          require(`../../assets/xianni/${this.imgMid}banner/5.png`)
        ]
      },
      immediate: true
    },
    currRole: {
      handler() {
        this.getImgSize()
      },
      immediate: true
    }
  },
  async mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.swiper()
    const res = await reserveUserNum()
    for (let i = 0; i < 5; i++) {
      this.moduleScrolls.push(Math.floor(document.getElementById(`module_${i + 1}`).getBoundingClientRect().top))
    }
    res.data.phone_people_num = 1900001
    for (let i = 0; i < this.lvNum.length; i++) {
      if (res.data.phone_people_num < this.lvNum[i]) {
        this.reserveLv = i
        return
      }
    }
    if (res.data.phone_people_num > this.lvNum[4]) {
      this.reserveLv = 5
    }
  },
  methods: {
    closeReser() {
      this.reservaVisible = false
      this.reShowReserve()
    },
    reShowReserve() {
      !this.isReserved &&
        setTimeout(() => {
          this.reservaVisible = true
        }, 15000)
    },
    handleScroll() {
      if (this.isScrolling) return
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      for (let i = 0; i < this.moduleScrolls.length; i++) {
        if (scrollTop < this.moduleScrolls[i]) {
          this.currMenu = Math.max(i, 1)
          return
        }
        if (i == this.moduleScrolls.length - 1 && scrollTop > this.moduleScrolls[i]) {
          this.currMenu = 5
        }
      }
    },
    async phoneConfirm(params) {
      this.loading = true
      try {
        const res = await reserveRegUserPhone({
          phone_type: params.selectValue.value,
          phone: params.inputvalue,
          app_type: this.isAppleDevice() ? 1 : 0
        })
        if (res.data.errorcode) {
          this.ispc
            ? this.$message.error(res.data.msg)
            : this.$toast({
                message: res.data.msg,
                className: 'toast_custom'
              })
        } else {
          if (!res.data.status_new) {
            this.repeatVisible = true
          } else {
            this.sucVisible = true
            this.reservationSuccess()
          }
          this.reservaVisible = false
          this.isReserved = true
          localStorage.setItem('isReserved', 1)
        }
      } finally {
        this.loading = false
      }
    },
    changeRoleType(index) {
      this.currRoleIndex = index
      this.currRole = this.roleNames[index].roles[0]
    },
    getImgSize() {
      const nImg = new Image()
      nImg.src = require(`@/assets/xianni/${this.imgMid}roles/info/${this.currRole}.png`)
      nImg.onload = () => {
        if (this.ispc) {
          this.roleInfoSize = {
            width: `${(nImg.width / 21.2).toFixed(1)}vw`,
            height: `${(nImg.height / 21.2).toFixed(1)}vw`
          }
        } else {
          const originHeight = nImg.height / 7.5
          const cHeight = 78.2
          this.roleInfoSize = {
            width: `${((nImg.width / 7.5) * (cHeight / originHeight)).toFixed(1)}vw`,
            height: `${cHeight}vw`
          }
        }
      }
    },
    isPC() {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        return false
      } else {
        return true
      }
    },
    isAppleDevice() {
      const userAgent = navigator.userAgent.toLowerCase()
      return /ipad|iphone os/i.test(userAgent)
    },
    toAppStore() {
      const source = this.$route.query.utm_source
      const storeLinks = {
        meta: 'https://apps.apple.com/app/id6756169358?ppid=ee6e5d21-e93d-448e-99d1-48a7550c1bf4',
        google: 'https://apps.apple.com/app/id6756169358?ppid=e2805a54-c4c9-447e-a4af-eb56400a7458',
        tiktok: 'https://apps.apple.com/app/id6756169358?ppid=1d209bc2-9247-4533-9954-77f62b248950',
        default: 'https://apps.apple.com/app/id6756169358' // 兜底：自然流量或参数丢失
      }
      if (source && storeLinks[source.toLowerCase()]) {
        location.href = storeLinks[source.toLowerCase()]
      } else {
        location.href = storeLinks['default']
      }
    },
    toGoogle() {
      if (this.ispc) {
        window.open('https://play.google.com/store/apps/details?id=com.xianni.tw')
      } else {
        location.href = 'https://play.google.com/store/apps/details?id=com.xianni.tw'
      }
    },
    toFB() {
      this.clickStore()
      if (this.ispc) {
        window.open('https://www.facebook.com/xnmobiletw')
      } else {
        location.href = 'https://www.facebook.com/xnmobiletw'
      }
    },
    report() {
      this.clickStore()
    },
    changeRole(role) {
      this.currRole = role
    },
    swiper() {
      this.forbid = false
      this.timer = setInterval(() => {
        this.isSwper = true
        this.bannerIndex++
      }, 3000)
    },
    swiperEnd() {
      if (this.bannerIndex > this.bannerList.length) {
        this.isSwper = false
        this.bannerIndex = 1
      }
      if (this.bannerIndex == 0) {
        this.isSwper = false
        this.bannerIndex = this.bannerList.length
      }
      !this.timer &&
        this.$nextTick(() => {
          this.swiper()
        })
    },
    changeBanner($event, sign) {
      if (this.forbid) return
      this.forbid = true
      clearInterval(this.timer)
      this.timer = null
      this.bannerIndex = this.bannerIndex + (sign == 'next' ? 1 : -1)
      this.isSwper = true
      $event.preventDefault()
    },
    changeMenu(index) {
      // if (this.isScrolling) return
      this.isScrolling = true
      this.currMenu = index
      window.scrollTo({
        top: this.moduleScrolls[index - 1] + 10,
        behavior: 'smooth'
      })
      clearTimeout(this.scrollTimer)
      this.scrollTimer = setTimeout(() => {
        this.isScrolling = false
      }, index * 500)
    },
    toUserprotocol() {
      window.open(`${location.href}userprotocol`)
    },
    toPrivate() {
      window.open(`${location.href}private`)
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  position: relative;
  // height: 100vh;
  // overflow: auto;
  img {
    display: flex;
  }
  .module_img {
    width: 100vw;
  }
  .top_banenr {
    position: relative;
  }
  .banner_btn {
    width: 25.3vw;
    height: 6.1vw;
    background: url('@/assets/xianni/yuyue.gif') no-repeat 0 0 / 100% auto;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    bottom: 0;
  }
  .step {
    position: relative;
  }
  .phone_input {
    position: absolute;
    top: 43.4vw;
    left: 23vw;
  }
  .download_btns {
    position: absolute;
    top: 39.4vw;
    left: 55.8vw;
    display: flex;
    flex-flow: row nowrap;
    gap: 1.8vw;
    .download_btn {
      width: 12.3vw;
      height: 3.6vw;
      background: url('@/assets/xianni/app_store_download.gif') no-repeat 0 0 / 100% auto;
      &.goole_btn {
        background: url('@/assets/xianni/goole_download.gif') no-repeat 0 0 / 100% auto;
      }
    }
  }
  .f_zan {
    position: absolute;
    width: 15.7vw;
    top: 51vw;
    right: 17vw;
    height: 3.9vw;
    background: url('@/assets/xianni/pop_f_zan.gif') no-repeat 0 0 / 100% auto;
  }
  .reservation_num {
    width: 100vw;
    height: 73.8vw;
    background: url('@/assets/xianni/2_03.jpg') no-repeat 0 0 / 100% auto;
    position: relative;
  }
  .num_dc {
    position: absolute;
    left: 51%;
    transform: translateX(-50%);
    top: 19vw;
    width: 61.8vw;
    height: 46.1vw;
    background: url('@/assets/xianni/dc_00.png') no-repeat 0 0 / 100% auto;
  }
  .dj {
    position: absolute;
    left: 51.2%;
    transform: translateX(-50%);
    top: 46.2vw;
    width: 12.4vw;
    height: 12.4vw;
    background: url('@/assets/xianni/dj.png') no-repeat 0 0 / 100% auto;
  }
  .num_lv {
    position: absolute;
    left: 51.2%;
    transform: translateX(-50%);
    bottom: 3vw;
    width: 22.7vw;
    height: 3.8vw;
    background: url('@/assets/xianni/lv_bg.png') no-repeat 0 0 / 100% auto;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 10.3vw;
      height: 3.5vw;
    }
    .lv_0 {
      width: auto;
      height: 3.5vw;
    }
  }
  .fans {
    width: 100vw;
    height: 70.1vw;
    background: url('@/assets/xianni/2_04.jpg') no-repeat 0 0 / 100% auto;
    position: relative;
    .fb_page_container {
      position: absolute;
      top: 17.6vw;
      right: 19vw;
      width: 24.34vw;
      height: 34.8vw;
    }
    .tip {
      font-size: 1.2vw;
      text-align: center;
      position: absolute;
      right: 15vw;
      bottom: 2vw;
      width: 32vw;
    }
  }
  .roles {
    width: 100vw;
    height: 65.45vw;
    background: url('@/assets/xianni/2_05.jpg') no-repeat 0 0 / 100% auto;
    position: relative;
    .role_names {
      // background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      position: absolute;
      top: 23.5vw;
      left: 22.6vw;
    }
    .n_item {
      cursor: pointer;
      width: 6.66vw;
      height: 2.6vw;
      img {
        width: inherit;
        height: inherit;
        display: block;
      }
    }
  }
  .roles_header {
    display: flex;
    position: absolute;
    top: 29.7vw;
    left: 24.8vw;
    width: 24vw;
    justify-content: space-between;
    .role_header {
      display: flex;
      position: relative;
      padding: 0.6vw;
      img {
        width: 6.3vw;
        height: 6.46vw;
      }
      &.curr_role:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: url('@/assets/xianni/header_select.png') no-repeat 0 0 / 100% auto;
      }
    }
  }
  .skill_container {
    position: absolute;
    top: 24vw;
    right: 18.4vw;
    width: 25.5vw;
    height: 31.6vw;
    // border: 1px solid #f00;
  }
  .role_skill {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .bot_banner {
    width: 100vw;
    height: 99.7vw;
    background: url('@/assets/xianni/2_06.jpg') no-repeat 0 0 / 100% auto;
    position: relative;
    box-sizing: border-box;
    padding-top: 21.4vw;
  }
  .acter_mid {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    .zhua {
      width: 11.97vw;
      height: 9.95vw;
    }
  }
  .acter_k {
    display: flex;
    box-sizing: border-box;
  }
  .acter_swiper {
    width: 58.4vw;
    height: 34.5vw;
    overflow: hidden;
  }
  .swiper_list {
    display: flex;
    width: calc(58.4vw * 6);
    img {
      width: 58.4vw;
      height: 34.5vw;
    }
    &.is_swpier {
      transition: all 0.4s ease-in-out;
    }
  }
  .banner_pos {
    display: block;
    width: 58.1vw;
    height: 2.14vw;
    margin: 3vw auto 0;
  }
  .bot_tips {
    height: 9vw;
    background-color: #2c2c2c;
    color: #fff;
    font-size: 0.9vw;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2vw;
  }
  .bot_icon {
    height: 6.6vw;
    width: 6.6vw;
  }
  .logo_bot {
    width: 17.9vw;
    height: 4.2vw;
    margin-right: 1vw;
  }
  .tips {
    margin-left: 4vw;
  }
  .argu {
    margin-top: 0.6vw;
    display: flex;
    gap: 2vw;
    a {
      color: #fff;
    }
  }
  .menu_list {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    left: 3vw;
    width: 16vw;
    height: 29.3vw;
    .menu_item {
      width: 16vw;
      height: 5.86vw;
    }
    &.menu_list_1 {
      background: url('@/assets/xianni/menu1.png') no-repeat 0 0 / 100% 29.3vw;
    }
    &.menu_list_2 {
      background: url('@/assets/xianni/menu2.png') no-repeat 0 0 / 100% 29.3vw;
    }
    &.menu_list_3 {
      background: url('@/assets/xianni/menu3.png') no-repeat 0 0 / 100% 29.3vw;
      width: 17.9vw;
    }
    &.menu_list_4 {
      background: url('@/assets/xianni/menu4.png') no-repeat 0 0 / 100% 29.3vw;
    }
    &.menu_list_5 {
      background: url('@/assets/xianni/menu5.png') no-repeat 0 0 / 100% 29.3vw;
    }
  }

  &.mobile_main {
    padding-top: 16.13vw;
    padding-bottom: 14.4vw;
    position: relative;
    .banner_btn {
      width: 36vw;
      height: 8.7vw;
    }
    .top_img {
      width: 100vw;
      height: 16.13vw;
      background: url('@/assets/xianni/mobile/top_img.png') no-repeat 0 0 / 100% auto;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 10;
      .top_to_fb {
        width: 34vw;
        height: 9vw;
        position: absolute;
        right: 1.6vw;
        top: 3.9vw;
        background: url('@/assets/xianni/mobile/top_fs.gif') no-repeat 0 0 / 100% auto;
      }
    }
    .bot_img {
      width: 100vw;
      height: 26.2vw;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 10;
      background: url('@/assets/xianni/mobile/bot_img.png') no-repeat 0 0 / 100% auto;
      .bot_to_gl {
        &.android_bot {
          background: url('@/assets/xianni/mobile/goole_download.gif') no-repeat 0 0 / 100% auto;
        }
        &.ios_bot {
          background: url('@/assets/xianni/mobile/app_store_download.gif') no-repeat 0 0 / 100% auto;
        }
        background: rgba(0, 0, 0, 0.5);
        width: 28.8vw;
        height: 8.6vw;
        position: absolute;
        right: 3.6vw;
        bottom: 3vw;
      }
    }
    .phone_input {
      position: absolute;
      top: 70.4vw;
      left: 50%;
      transform: translateX(-50%);
    }
    .download_btns {
      top: 145vw;
      left: 52%;
      transform: translateX(-50%);
      gap: 4vw;
      .download_btn {
        width: 31.2vw;
        height: 9.2vw;
        background: url('@/assets/xianni/mobile/app_store_download.gif') no-repeat 0 0 / 100% auto;
        &.goole_btn {
          background: url('@/assets/xianni/mobile/goole_download.gif') no-repeat 0 0 / 100% auto;
        }
      }
    }
    .reservation_num {
      height: 102.9vw;
      background: url('@/assets/xianni/mobile/2_03.jpg') no-repeat 0 0 / 100% auto;
      .num_dc {
        left: 50%;
        transform: translateX(-50%);
        top: 19vw;
        width: 93.1vw;
        height: 71.46vw;
      }
      .dj {
        left: 50%;
        transform: translateX(-50%);
        top: 60.2vw;
        width: 18.6vw;
        height: 18.8vw;
      }
      .num_lv {
        left: 50%;
        bottom: 4vw;
        width: 34.26vw;
        height: 5.73vw;
        img {
          width: 15.46vw;
          height: 4.9vw;
        }
        .lv_0 {
          width: auto;
          height: 4.9vw;
        }
      }
    }
    .f_zan {
      width: 40.1vw;
      top: 207vw;
      left: 50%;
      transform: translateX(-50%);
      height: 10.8vw;
      background: url('@/assets/xianni/mobile/pop_f_zan.gif') no-repeat 0 0 / 100% auto;
    }

    .fans {
      width: 100vw;
      height: 98.5vw;
      background: url('@/assets/xianni/mobile/2_04.jpg') no-repeat 0 0 / 100% auto;
      position: relative;
      .fb_page_container {
        top: 21.2vw;
        right: unset;
        left: 50.3vw;
        transform: translateX(-50%);
        width: 50.7vw;
        height: 57.2vw;
      }
      .tip {
        text-align: center;
        font-size: 2.4vw;
        right: 0;
        bottom: 3vw;
        top: unset;
        width: 100vw;
      }
    }
    .roles {
      height: 168.9vw;
      background: url('@/assets/xianni/mobile/2_05.jpg') no-repeat 0 0 / 100% auto;
      .role_names {
        top: 109.9vw;
        left: 17.4vw;
      }
      .n_item {
        width: 13.33vw;
        height: 5.2vw;
      }
    }
    .roles_header {
      top: 124vw;
      left: 21vw;
      width: 58.8vw;
      .role_header {
        padding: 1.6vw;
        img {
          width: 15.46vw;
          height: 15.86vw;
        }
      }
    }
    .skill_container {
      top: 55vw;
      right: unset;
      left: 50%;
      transform: translateX(-50%);
    }
    .role_skill {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .bot_banner {
      width: 100vw;
      height: 121.46vw;
      background: url('@/assets/xianni/mobile/2_06.jpg') no-repeat 0 0 / 100% auto;
      padding-top: 23.4vw;
    }
    .acter_mid {
      gap: 1vw;
      .zhua {
        width: 5.6vw;
        height: 6.4vw;
      }
    }
    .acter_swiper {
      width: 84.13vw;
      height: 49.6vw;
    }
    .swiper_list {
      width: calc(84.13vw * 6);
      img {
        width: 84.13vw;
        height: 49.6vw;
      }
    }
    .banner_pos {
      width: 83.73vw;
      height: 3.06vw;
      margin: 3.4vw auto 0;
    }
  }
}

.suc_dia {
  width: 92.6vh;
  height: 60vh;
  position: relative;
  background: url('@/assets/xianni/pop_1.png') no-repeat 0 0 / 100% 100%;
  &.repeat_phone {
    background: url('@/assets/xianni/pop_0.png') no-repeat 0 0 / 100% 100%;
    width: 99.4vh;
  }
  &.android_suc {
    // background: url('@/assets/xianni/pop_2.png') no-repeat 0 0 / 100% 100%;
  }
  &.ios_suc {
    // background: url('@/assets/xianni/pop_3.png') no-repeat 0 0 / 100% 100%;
  }
  .close {
    position: absolute;
    width: 10vh;
    height: 10vh;
    top: 0;
    right: 0;
  }
  .dia_btns {
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 6.2vh;
    // left: 27.8vh;
    left: 0;
    right: 0;
    gap: 1.8vh;
    padding-right: 2vh;
    > div {
      width: 16.8vh;
      height: 4.8vh;
    }
    .apple_btn {
      background: url('@/assets/xianni/app_store_download.gif') no-repeat 0 0 / 100% 100%;
    }
    .gl_btn {
      background: url('@/assets/xianni/goole_download.gif') no-repeat 0 0 / 100% 100%;
    }
  }
  .dia_fb {
    position: absolute;
    bottom: 4vh;
    left: 30.8vh;
    width: 32vh;
    height: 8.4vh;
    background: url('@/assets/xianni/pop_f_zan.gif') no-repeat 0 0 / 100% 100%;
  }
  &.mobile_suc {
    width: 78.94vw;
    height: 51.14vw;
    &.repeat_phone {
      height: 45.75vw;
    }
    .close {
      position: absolute;
      width: 8vw;
      height: 8vw;
      top: 0;
      right: 0;
    }
    .dia_btns {
      display: flex;
      justify-content: center;
      position: absolute;
      bottom: 5.4vw;
      // left: 23vw;
      gap: 1.6vw;
      padding-right: 2vw;
      > div {
        width: 14.8vw;
        height: 4.5vw;
      }
    }
    .dia_fb {
      bottom: 2.8vw;
      left: 25.2vw;
      width: 24vw;
      height: 6.3vw;
    }
  }
}

.reserva_dia {
  display: flex;
  justify-content: center;
  .reserva_container {
    position: relative;
    transform: scale(0.94);
  }
  .reserva_pop_bg {
    display: block;
    height: 100vh;
    width: auto;
  }
  .close {
    position: absolute;
    width: 4.6vh;
    height: 4.6vh;
    top: 0;
    right: 8vh;
  }
}

::v-deep .el-dialog {
  background: transparent;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

::v-deep .el-dialog__header {
  padding: 0;
}

::v-deep .el-dialog__body {
  padding: 0;
  background: transparent;
}
</style>

<style>
.toast_custom {
  z-index: 9999 !important;
}
</style>
